import React from 'react';
import close from '../../assets/icons/popup_close.svg'
import {Button,message} from 'antd'

const IDPSuggessionandRejectView = ( props ) => {
    const { onCancel ,onSuccess} = props
    const [comment,setComment]=React.useState("")
    const Confirm =()=>{
        if(comment && comment?.trim() !== ""){
            onSuccess(comment)
        }else{
            message.error("Add suggestions")
        }
        
    }
    return (
        <>
            <div className="row-space-between">
                <h4 className="idp-form-label" style={{ fontWeight: "500",margin:0 }}>Give Suggestions</h4>
                <img src={close} alt="close" onClick={() => { onCancel() }} style={{ cursor: "pointer" }} />
            </div>
            <div style={{display:"flex",flexDirection:"column",gap:"1em",marginTop:"1em"}}>
                <textarea className="idp-textarea" placeholder="Write your suggestions here" onChange={(e)=>setComment(e?.target?.value)}/>
            </div>
            <div style={{display:'flex',justifyContent:"end",marginTop:"2.5em"}}>
                <Button className='idp-cancel idp-btn'onClick={() => { onCancel() }}>CANCEL</Button>
                <Button className='idp-submit-outline idp-btn'onClick={() => { Confirm() }}>CONFIRM</Button>
            </div>
        </>
    )
}

export default IDPSuggessionandRejectView